import dashboardIcon from '../../assets/agent-hub/icons/dashboard.png';
import agentsIcon from '../../assets/agent-hub/icons/agents.png';
import chatIcon from '../../assets/agent-hub/icons/chat.png';
import oversightIcon from '../../assets/agent-hub/icons/oversight.png';
import ledgerIcon from '../../assets/agent-hub/icons/ledger.png';
import statementsIcon from '../../assets/agent-hub/icons/statements.png';
import withdrawalsIcon from '../../assets/agent-hub/icons/withdrawals.png';
import profitSharingIcon from '../../assets/agent-hub/icons/profit-sharing.png';
import referralsIcon from '../../assets/agent-hub/icons/referrals.png';
import broadcastIcon from '../../assets/agent-hub/icons/broadcast.png';
import domainsIcon from '../../assets/agent-hub/icons/domains.png';
import auditIcon from '../../assets/agent-hub/icons/audit.png';
import settingsIcon from '../../assets/agent-hub/icons/settings.png';

export const HUB_SECTION_ASSETS = {
  dashboard: dashboardIcon,
  leads: agentsIcon,
  agents: agentsIcon,
  chat: chatIcon,
  oversight: oversightIcon,
  ledger: ledgerIcon,
  statements: statementsIcon,
  withdrawals: withdrawalsIcon,
  'profit-sharing': profitSharingIcon,
  referrals: referralsIcon,
  broadcast: broadcastIcon,
  domains: domainsIcon,
  audit: auditIcon,
  settings: settingsIcon,
};

export function HubAssetIcon({ src, className = '', alt = '' }) {
  return (
    <img
      className={`hub-asset-icon ${className}`.trim()}
      src={src}
      alt={alt}
      aria-hidden={alt ? undefined : 'true'}
    />
  );
}
